import React, { useEffect } from "react";
import { useState } from "react";
import { CiCircleRemove } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Button, Col, Container, Row, Spinner } from "reactstrap";
import {
    getQrRequest,
    submitQrCode,
} from "../../store/actions/MomentosActions";
import { toast } from "react-toastify";

const UploadQRcode = () => {
    const dispatch = useDispatch();
    const [requestDetails, setRequestDetails] = useState(null);
    const { id } = useParams();
    const { loading } = useSelector((state) => state.momentos);

    useEffect(() => {
        dispatch(
            getQrRequest(id, (res) => {
                setRequestDetails(res);
            })
        );
    }, [id]);

    const [qrCodeImg, setQrCodeImg] = useState("");

    const handleUploadClick = () => {
        const fileInput = document.getElementById(`upload-button`);
        fileInput.click();
    };
    const handleFileChange = (e) => {
        if (e.target.files.length) {
            setQrCodeImg(e.target.files[0]);
        }
    };
    const handleRemove = (e) => {
        setQrCodeImg("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let payload = {
            email: requestDetails?.email,
            userId: requestDetails?.userId,
            userName: requestDetails?.userName,
            url: qrCodeImg,
        };

        dispatch(
            submitQrCode(id, payload, () => {
                toast.success("QR Code Submitted Successfully");
                setRequestDetails(null);
            })
        );
    };
    return (
        <Container fluid>
            {loading ? (
                <Row className="justify-content-center my-5">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <>
                    <Row className="justify-content-center flex-column align-items-center mx-4 py-3">
                        <h3>QR-Code Submission</h3>
                        {requestDetails !== null && (
                            <p>
                                You are Submitting a QR to{" "}
                                {requestDetails?.userName}
                            </p>
                        )}
                    </Row>
                    {requestDetails !== null && (
                        <Container className="d-flex justify-content-center">
                            <Row className="d-flex flex-column justify-content-center align-items-center">
                                <Col className="d-flex justify-content-center">
                                    <div>
                                        <Button
                                            onClick={() => handleUploadClick()}
                                            disabled={qrCodeImg}
                                            style={{
                                                display: qrCodeImg
                                                    ? "none"
                                                    : "block",
                                            }}
                                            color="primary"
                                        >
                                            Upload File
                                        </Button>
                                        <input
                                            type="file"
                                            id={`upload-button`}
                                            style={{
                                                display: "none",
                                            }}
                                            accept=".jpg , .png , .jpeg"
                                            onChange={(e) =>
                                                handleFileChange(e)
                                            }
                                        />
                                    </div>
                                </Col>
                                {qrCodeImg && (
                                    <Col className="d-flex flex-column align-items-center my-4 justify-content-center">
                                        <div className="position-relative d-flex justify-content-center ">
                                            <img
                                                className="w-25"
                                                src={
                                                    qrCodeImg instanceof File
                                                        ? URL.createObjectURL(
                                                              qrCodeImg
                                                          )
                                                        : null
                                                }
                                            />
                                            <CiCircleRemove
                                                className="QR-code-remove"
                                                style={{ left: "62%" }}
                                                onClick={(e) => handleRemove(e)}
                                            />
                                        </div>
                                        <Button
                                            className="px-4 mt-4"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            Submit
                                        </Button>
                                    </Col>
                                )}
                            </Row>
                        </Container>
                    )}
                </>
            )}
        </Container>
    );
};

export default UploadQRcode;
